import React, {useContext, useEffect, useState} from "react";
import AuthCheck from "../components/AuthCheck";
import {Button, Card, Col, Row, Modal, Form} from "react-bootstrap";
import {Link, useNavigate} from "react-router-dom";
import {accountContext} from "../App";
import FilterBar from "../components/elements/FilterBar";
import SortBar from "../components/elements/SortBar";
import TableList from "../components/table/TableList";
import tableDataModules from "../controller/tableDataModules";
import tableDataPatientcases from "../controller/tableDataPatientcases";
import axios from "axios";

let tblDataCache = null;
function Home() {
    let navigate = useNavigate();

    const [selectedModule,selectModule] = useState(null);
    const [tblCase,setTblCase] = useState([]);
    const [tblModule,setTblModule] = useState([]);
    
    // States for module editing
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingModule, setEditingModule] = useState(null);
    const [moduleName, setModuleName] = useState("");

    useContext(accountContext);

    let tlbdata2 = tableDataPatientcases();

    useEffect(()=>{
        loadModules();
    }, []);

    const loadModules = () => {
        tableDataModules.getModuleOverview().then(val => {
            if(val.length !== 0){
                selectModuleEvent(val[0][0]);
            }
            setTblModule(val);
        });
    };

    function setFilter(filterText) {
        let tblSearch = [];
        
        // Always rebuild the cache if it's null or we're clearing the filter
        if(tblDataCache === null || filterText === ''){
            // Store a deep copy of the module data to avoid reference issues
            tblDataCache = JSON.parse(JSON.stringify(tblModule));
        }
        
        if (filterText === '') {
            // If filter is cleared, show all modules
            setTblModule(tblDataCache);
            return;
        }
        
        // Filter based on the search text
        for (const val of tblDataCache) {
            if(val[1].toLowerCase().includes(filterText.toLowerCase())){
                tblSearch.push(val);
            }
        }
        
        setTblModule(tblSearch);
    }
    
    function selectModuleEvent(moduleID){
        selectModule(moduleID);

        tableDataModules.getCasesFromModule(moduleID).then(casefiles =>{
            let rowData = [];
            for (let i = 0; i < casefiles.length; i++) {
                let casedata = casefiles[i];
                rowData.push([casedata.id,casedata.name,casedata.createdOn,casedata.deadline,casedata.submissions.length]);
            }
            setTblCase(rowData);
        });
    }

    async function enrollCodeButton() {
        try {
            const response = await axios.get('/api/module/' + selectedModule + '/code');
            const data = response.data;
            alert(`${data}`);
        } catch (error) {
            console.error(error);
        }
    }

    // Handle edit button click from the table
    const handleEditModule = (moduleId) => {
        const module = tableDataModules.lastModulesTable[moduleId];
        if (module) {
            setEditingModule(moduleId);
            setModuleName(module.name);
            setShowEditModal(true);
        }
    };

    // Handle delete button click
    const handleDeleteModule = () => {
        if (editingModule) {
            tableDataModules.deleteModule(editingModule)
                .then(() => {
                    // Clean up cache
                    if (tableDataModules.lastModulesTable && tableDataModules.lastModulesTable[editingModule]) {
                        delete tableDataModules.lastModulesTable[editingModule];
                    }
                    
                    // Reset the filter cache
                    tblDataCache = null;
                    
                    setShowDeleteModal(false);
                    setShowEditModal(false);
                    
                    // Reload modules after deletion
                    loadModules();
                    
                    // Reset selected module if the deleted one was selected
                    if (selectedModule === editingModule) {
                        selectModule(null);
                    }
                })
                .catch(err => {
                    alert("Error deleting module: " + err.message);
                });
        }
    };

    // Handle saving module changes
    const handleSaveModuleChanges = () => {
        if (editingModule) {
            tableDataModules.updateModule(editingModule, { name: moduleName })
                .then((res) => {
                    // Immediately update the local cache entry with the new name
                    // This ensures the right name shows up even without a reload
                    if (tableDataModules.lastModulesTable && tableDataModules.lastModulesTable[editingModule]) {
                        tableDataModules.lastModulesTable[editingModule].name = moduleName;
                    }
                    
                    // Reset the filter cache so it rebuilds with updated names
                    tblDataCache = null;
                    
                    setShowEditModal(false);
                    
                    // Reload modules after update to refresh the list
                    loadModules();
                })
                .catch(err => {
                    alert("Error updating module: " + err.message);
                });
        }
    };

    // Handle action button click from TableTypeButton component
    const handleActionButtonClick = (action, rowData) => {
        if (action === "edit") {
            // rowData[0] is the module ID
            handleEditModule(rowData[0]);
        }
    };

    return(
        <>
            <AuthCheck/>
            <Row style={{  marginTop: "20px"}}>
                <Col xs={{span: 6}}>
                    <Row>
                        <Col md={4}>
                            <FilterBar callback={setFilter}/>
                        </Col>
                        <Col md={4}>
                            <SortBar/>
                        </Col>
                        <Col md={{span: 3, offset: 1}}>
                            <Link to="/module/create"><Button style={{width: "100%"}} variant="success">New Module</Button></Link>
                        </Col>
                    </Row>
                    <Row>
                        <TableList 
                            selected={(index,item) => selectModuleEvent(item[0])} 
                            columnData={tableDataModules.getColumnData()} 
                            rowData={tblModule.map(row => {
                                // Add an empty entry for the action button
                                return [...row, ""];
                            })}
                            actionHandler={handleActionButtonClick}
                        />
                    </Row>
                </Col>
                <Col xs={{span: 6}}>
                    <Card >
                        <Card.Body>
                            {selectedModule ?
                            <Row>
                                <Col>
                                    <h2>{tableDataModules.lastModulesTable[selectedModule].name}</h2>
                                </Col>
                                <Col>
                                    <Button onClick={enrollCodeButton} className="float-end">Enroll-code</Button>
                                </Col>
                            </Row>
                                : "Loading..."}


                            <hr/>
                            <h4>Patient cases</h4>
                            <Row>
                                <Col md={4}>
                                    <FilterBar/>
                                </Col>
                                <Col md={4}>
                                    <SortBar/>
                                </Col>
                                <Col md={{span: 3, offset: 1}}>
                                    <Link to={"/case/create/"+selectedModule+"/"}><Button style={{width: "100%"}} variant="success">New Case</Button></Link>
                                </Col>
                            </Row>
                            <Row>
                                <TableList 
                                    selected={(index,item) => navigate("/case/"+item[0]+"/students")} 
                                    columnData={tlbdata2[0]} 
                                    rowData={tblCase}
                                />
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Edit Module Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Module</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => {
                        e.preventDefault(); // Prevent default form submission
                        handleSaveModuleChanges(); // Call our save function
                    }}>
                        <Form.Group className="mb-3">
                            <Form.Label>Module Name</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={moduleName} 
                                onChange={(e) => setModuleName(e.target.value)}
                                autoFocus
                            />
                        </Form.Group>
                        {/* Hidden submit button to catch Enter key */}
                        <Button type="submit" style={{ display: 'none' }}>Submit</Button>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setShowDeleteModal(true)}>
                        Delete Module
                    </Button>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSaveModuleChanges}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this module?</p>
                    <p><strong>This will delete all associated cases and cannot be undone!</strong></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteModule}>
                        Delete Module
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Home;